import type { SyntaxNode } from 'web-tree-sitter';
import { assertBackgroundIndexingAllowed, yieldForBridgeInteractivePriority } from '../../files/browser/in-flight.js';
import type { LoadedLanguage } from './tree-sitter-runtime.js';

/** Run a tree-sitter tags query, yielding before the blocking native work. */
export async function runTagsQuery(loaded: LoadedLanguage, root: SyntaxNode) {
  await yieldForBridgeInteractivePriority();
  assertBackgroundIndexingAllowed();
  const matches = loaded.query.matches(root);
  assertBackgroundIndexingAllowed();
  await yieldForBridgeInteractivePriority();
  return matches;
}
